<template>
    <div>
        <Pos_edit_promotion_new />
    </div>
</template>
  
<script>
import Pos_edit_promotion_new from "@/components/adminArin/pos_system/warehouse/manage_promotion/Pos_edit_promotion_new";
export default {
    name: "PosEditPromotionNew",
    components: {
        Pos_edit_promotion_new
    }
}
</script>
  
<style scoped></style>
  